import { memo, SVGProps } from 'react'

export const PlaySafeDepositLimitIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411.75 411.75">
    <path
      fill="#fff"
      strokeWidth="5px"
      stroke="#3a434f"
      d="M354.63,139.38V268.43a19,19,0,0,1-18.89,18.85H82.07A19,19,0,0,1,63.2,268.43v-129a18.86,18.86,0,0,1,18.87-18.74H335.74A18.88,18.88,0,0,1,354.63,139.38Z"
    />
    <path opacity="0.08" d="M312.24,287.28H82.07A19,19,0,0,1,63.2,268.43V174.72S97.49,287.28,312.24,287.28Z" />
    <rect fill="#464e5b" x="63.27" y="145.14" width="291.27" height="29.58" />
    <rect fill="#ccc" x="84.34" y="188.22" width="253.09" height="15.69" />
    <rect fill="#ccc" x="91.13" y="193.73" width="30.14" height="4.7" />
    <rect fill="#ccc" x="167.64" y="228.89" width="82.26" height="4.7" rx="1.63" />
    <rect fill="#ccc" x="255.17" y="228.89" width="25.76" height="4.7" rx="0.91" />
    <rect fill="#ccc" x="167.64" y="240.62" width="38.06" height="4.7" rx="1.11" />
    <rect fill="#ccc" x="211.85" y="240.62" width="81.3" height="4.7" rx="1.63" />
    <rect fill="#ccc" x="167.64" y="251.71" width="98.66" height="4.7" rx="1.79" />
    <rect fill="#ccc" x="272.05" y="251.71" width="31.14" height="4.7" rx="1.01" />
    <rect fill="#ccc" x="84.34" y="228.89" width="67.79" height="35.66" rx="6.95" />
    <rect fill="#ccc" x="131.15" y="193.73" width="11.33" height="4.7" />
  </svg>
))

export const PlaySafeBetLimitIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411.75 411.75">
    <rect fill="#464e5b" x="74.77" y="105.49" width="268.19" height="175.24" rx="12.19" />
    <rect fill="#f6f6f6" x="86.23" y="117.05" width="245.26" height="151.44" />
    <rect fill="#e2e2e2" x="178.01" y="279.47" width="61.72" height="12.01" />
    <path
      fill="#464e5b"
      fillRule="evenodd"
      d="M371.85,282.17c0,9.64-5.09,17.47-11.36,17.47H57.24c-6.27,0-11.35-7.83-11.35-17.47a25.34,25.34,0,0,1,.21-3.36H179.81a7.77,7.77,0,0,0,7.42,5H230.5a7.77,7.77,0,0,0,7.42-5H371.63A25.28,25.28,0,0,1,371.85,282.17Z"
    />
    <circle fill="#e9523f" cx="211.15" cy="192.63" r="66.25" />
    <path
      fill="#23272e"
      d="M205.7,231.19a65,65,0,0,1-23-5.35v-18.1a78.87,78.87,0,0,0,13.74,5.37,47.37,47.37,0,0,0,13,2.15q4.64,0,6.79-1.11a3.89,3.89,0,0,0,2.16-3.74,3.78,3.78,0,0,0-1.56-3,24.13,24.13,0,0,0-5.18-2.84q-3.63-1.58-9.79-3.82A44.28,44.28,0,0,1,190.7,195a20.19,20.19,0,0,1-6.19-7.14,22.34,22.34,0,0,1-1.93-9.85q0-9,5.78-14.07t17.34-6.27v-12.1H217v12a63.93,63.93,0,0,1,21.87,5.35l-6.49,15.54q-11.4-5.13-20.56-5.13-4.37,0-6.14,1.07a3.42,3.42,0,0,0-1.77,3.13,3.86,3.86,0,0,0,1.28,3,17.61,17.61,0,0,0,4.45,2.62q3.15,1.44,8.78,3.35,11.39,4.05,16.36,9.19t5,13.28q0,9.17-5.81,14.89T217,230.86v14.59H205.7Z"
    />
  </svg>
))

export const PlaySafeSessionTimeoutIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411.75 411.75">
    <path
      fill="#fff"
      d="M287.19,317.63c-2.64-.57-5.35-.78-9-1.29,0-5.29,0-10.47,0-15.65.16-20.58-6.79-38.19-20.94-52.62-7.76-7.93-16.11-15.26-23.64-23.4a36.32,36.32,0,0,1-7.86-13.1c-3.27-10.25,1.52-18.41,8.38-25.36,8.36-8.46,17.15-16.46,25.32-25.09a64.65,64.65,0,0,0,17.73-37.88c1-9.16,1.14-18.43,1.69-28.13,2.1-.31,4.18-.64,6.27-.93,6.64-.93,10.84-5.45,10.5-11.32-.36-6.22-5.09-10.31-12-10.32q-58.47,0-116.94,0-16.66,0-33.32.49c-5.43.16-9.42,4.57-9.67,10.07a10.68,10.68,0,0,0,8.38,10.83c2.66.54,5.37.79,9.11,1.31,0,5.5,0,10.51,0,15.53-.22,20.34,6.46,37.87,20.38,52.24,7.72,8,16,15.32,23.75,23.28,12.47,12.87,12.49,26.2,0,39.07-6.48,6.68-13.47,12.84-20.14,19.32-16,15.53-24.64,34.39-24.06,57.38.12,4.76,0,9.52,0,14.36-3.49.47-6,.7-8.46,1.18a10.89,10.89,0,0,0-9,11.55c.61,5.94,4.67,9.91,10.53,9.91q75.44.06,150.87,0c5.78,0,9.91-4.1,10.48-10A11.08,11.08,0,0,0,287.19,317.63Z"
    />
    <path
      fill="#e9523f"
      d="M263,128.16c-2.91,12.06-9.51,21.09-17.63,29.07-6.21,6.11-12.62,12-18.9,18-8.08,7.76-11.22,17.36-14.84,28.55-.39,1.22-1.12,3.71-1.88,6-.82-2.39-1.58-5.09-2-6.62-3.05-10.79-6.67-20-14.37-27.57S177.61,160.6,170,152.84c-6.61-6.72-10.93-14.93-13.74-24.68Z"
    />
    <path
      fill="#e9523f"
      d="M261.51,311.78H156.68c2.15-1.92,3.3-3.14,4.62-4.1,13.18-9.65,26.34-19.32,39.61-28.84,8.52-6.11,8.6-6,16.44-.87,3.47,2.37,3,2.1,6.77,4.8L262,310.46C261.86,310.9,261.69,311.34,261.51,311.78Z"
    />
    <rect fill="#464e5b" x="123.7" y="72.49" width="172" height="22.79" rx="6.02" />
    <rect fill="#464e5b" x="123.7" y="316.57" width="172" height="22.79" rx="6.02" />
    <path
      fill="#e2e2e2"
      d="M205.46,95.1V74.18h-8.63c-10,0-20-.41-30.07-.4-11.1,0-22,.2-33.07.52-5.23.15-6.1,18.5-1.56,19.44,2.66.55,9.11-2.47,9.11-2.47,0,5.46,0,14.33,0,19.31-.22,20.35,6.42,37.87,20.34,52.24,7.72,8,16,15.33,23.74,23.29,12.48,12.86,12.5,26.2.05,39.06-6.48,6.69-13.47,12.84-20.14,19.32-16,15.54-24.64,34.39-24.06,57.39.12,4.75,0,9.52,0,14.35-.51.07,39.14,22.82,64.28,22.82V316.39h4.29V95.1Z"
    />
    <path
      fill="#af3e2f"
      d="M209.75,128v81.7c-.81-2.4-1.59-5.09-2-6.62-3.06-10.79-6.68-20-14.38-27.57S177.62,160.45,170,152.69c-6.62-6.72-10.94-15-13.75-24.69Z"
    />
    <path
      fill="#af3e2f"
      d="M209.75,274.05v37.59H156.68c2.15-1.85,3.3-3.14,4.62-4.1,13.18-9.65,26.35-19.33,39.62-28.84C205.42,275.48,207.55,274,209.75,274.05Z"
    />
    <path fill="#323944" d="M209.75,72.39V95.1h-80a5.9,5.9,0,0,1-5.94-5.95V78.39a6,6,0,0,1,5.94-6Z" />
    <path fill="#323944" d="M209.75,316.39v22.83h-80a6,6,0,0,1-5.94-6V322.44a6,6,0,0,1,5.94-6.05Z" />
    <circle fill="#e9523f" cx="208.95" cy="222.73" r="3.96" />
    <circle fill="#e9523f" cx="215.91" cy="236.51" r="3.96" />
    <path fill="#e9523f" d="M212,251.3a4,4,0,1,1-4-4A4,4,0,0,1,212,251.3Z" />
    <path fill="#e9523f" d="M216.87,266.1a4,4,0,1,1-4-4A4,4,0,0,1,216.87,266.1Z" />
  </svg>
))

export const PlaySafeLossLimitIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411.75 411.75">
    <path
      fill="#e9523f"
      d="M205.88,68.94,92.47,114.77V228.46s6.69,79.16,113.41,123.11c106.71-43.95,113.4-123.11,113.4-123.11V114.77Z"
    />
    <path fill="#464e5b" d="M205.88,97.81l-90.24,36.48v90.44s5.33,63,90.24,98c84.9-35,90.23-98,90.23-98V134.29Z" />
    <path
      fill="#231f20"
      opacity="0.1"
      d="M319.28,228.46V114.77L205.88,68.94V351.57C312.59,307.62,319.28,228.46,319.28,228.46Z"
    />
    <path
      fill="#fff"
      d="M198.88,250.41a83.09,83.09,0,0,1-29.51-6.85V220.34A100.09,100.09,0,0,0,187,227.23,61,61,0,0,0,203.71,230c4,0,6.86-.47,8.7-1.43a5,5,0,0,0,2.77-4.79,4.86,4.86,0,0,0-2-3.91,30.38,30.38,0,0,0-6.64-3.64q-4.65-2-12.55-4.9A57.14,57.14,0,0,1,179.65,204a25.75,25.75,0,0,1-7.93-9.16,28.54,28.54,0,0,1-2.49-12.63q0-11.53,7.42-18t22.23-8V140.56h14.48v15.38a82.19,82.19,0,0,1,28,6.85l-8.32,19.93q-14.62-6.57-26.36-6.57c-3.73,0-6.36.45-7.87,1.36a4.4,4.4,0,0,0-2.27,4,5,5,0,0,0,1.64,3.82,22.84,22.84,0,0,0,5.7,3.35q4.05,1.86,11.26,4.3,14.61,5.17,21,11.79t6.37,17q0,11.76-7.45,19.09T213.36,250v18.72H198.88Z"
    />
  </svg>
))

export const PlaySafeSelfExclusionIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411.75 411.75">
    <rect fill="#464e5b" x="113.48" y="169.67" width="186.63" height="147.61" rx="6.64" />
    <path
      fill="#3a434f"
      d="M120.18,169.67h79.91a6.7,6.7,0,0,1,6.7,6.7V315.28a2,2,0,0,1-2,2H120.18a6.7,6.7,0,0,1-6.7-6.7V176.37A6.7,6.7,0,0,1,120.18,169.67Z"
    />
    <path
      fill="#e9523f"
      d="M120,169.67h173.5a6.56,6.56,0,0,1,6.56,6.56v27a0,0,0,0,1,0,0H113.48a0,0,0,0,1,0,0v-27A6.56,6.56,0,0,1,120,169.67Z"
    />
    <path
      fill="#db4237"
      d="M120,169.67h86.77a0,0,0,0,1,0,0v33.6a0,0,0,0,1,0,0H113.48a0,0,0,0,1,0,0V176.21A6.54,6.54,0,0,1,120,169.67Z"
    />
    <path
      fill="#fff"
      d="M233.18,237.31c0-12.13-11.79-22-26.53-22s-26.42,9.83-26.42,22c0,7.79,4.64,14.63,12.64,18.53v38.79c0,2.85,2.43,4.84,5.89,4.84h16.47c3.46,0,5.64-2,5.64-4.84v-39C228.87,251.71,233.18,245,233.18,237.31Z"
    />
    <path
      fill="#e8e8e8"
      d="M206.87,215.35v84.12h-8.11c-3.46,0-5.89-2-5.89-4.84V255.84c-8-3.89-12.52-10.73-12.52-18.53C180.35,225.19,192.87,215.37,206.87,215.35Z"
    />
    <path
      fill="#464e5b"
      d="M270.48,103.79C260.31,88.15,239.32,71,210.63,69.71c-2.54-.12-5.08-.08-7.62,0-28.69.92-49.68,18.44-59.86,34.08a84.55,84.55,0,0,0-13.72,45.55v40.54a3.77,3.77,0,0,0,1.93,3.27c9.74,5.49,19.27,2,23.35,0a3.73,3.73,0,0,0,2.08-3.35l-.07-37.84c0-13.11,3.58-26.49,12.13-35.86,16.79-18.39,36.73-17.89,37.94-17.84h.06c1.2,0,21.14-.55,37.94,17.84,8.55,9.37,12.15,22.75,12.13,35.86L256.85,190a3.35,3.35,0,0,0,1.82,3c4,2,13.86,5.86,23.92,0a3.33,3.33,0,0,0,1.62-2.87V149.34A84.48,84.48,0,0,0,270.48,103.79Z"
    />
    <path
      fill="#3a434f"
      d="M283.89,149.21V190a3.35,3.35,0,0,1-1.61,2.88,22.49,22.49,0,0,1-11,3.12v-45.8A70.71,70.71,0,0,0,259.79,112C251.27,99,233.71,84.6,209.7,83.52c-2.13-.1-4.26-.07-6.39,0-24,.77-41.57,15.44-50.09,28.52a70.72,70.72,0,0,0-11.49,38.13V196A22.44,22.44,0,0,1,131.05,193a3.75,3.75,0,0,1-1.94-3.27V149.21a84.5,84.5,0,0,1,13.73-45.55C153,88,174,70.51,202.69,69.59c2.54-.09,5.09-.12,7.63,0C239,70.88,260,88,270.17,103.66A84.49,84.49,0,0,1,283.89,149.21Z"
    />
  </svg>
))

export const PlaySafeRealityCheckIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411.75 411.75">
    <path
      fill="#fff"
      d="M208.87,70.63a20.52,20.52,0,1,1-20.52,20.52,20.52,20.52,0,0,1,20.52-20.52m0-6.29a26.82,26.82,0,1,0,26.81,26.81,26.85,26.85,0,0,0-26.81-26.81Z"
    />
    <rect
      fill="#23272e"
      x="144.82"
      y="134.4"
      width="14.77"
      height="30.55"
      transform="matrix(0.8, -0.6, 0.6, 0.8, -59.34, 121.01)"
    />
    <path
      fill="#464e5b"
      d="M130.82,116.57h10.93a3.39,3.39,0,0,1,3.39,3.39v20.26a0,0,0,0,1,0,0h-17.7a0,0,0,0,1,0,0V120A3.39,3.39,0,0,1,130.82,116.57Z"
      transform="translate(-49.76 107.24) rotate(-36.8)"
    />
    <rect
      fill="#23272e"
      x="254.79"
      y="134.4"
      width="14.77"
      height="30.55"
      transform="translate(382.42 426.59) rotate(-143.2)"
    />
    <path
      fill="#464e5b"
      d="M269.24,116.57h17.7a0,0,0,0,1,0,0v20.26a3.39,3.39,0,0,1-3.39,3.39H272.63a3.39,3.39,0,0,1-3.39-3.39V116.57a0,0,0,0,1,0,0Z"
      transform="translate(423.83 397.8) rotate(-143.2)"
    />
    <rect
      fill="#23272e"
      x="199.96"
      y="97.82"
      width="16.46"
      height="30.55"
      transform="translate(415.97 226.95) rotate(-179.79)"
    />
    <path
      fill="#464e5b"
      d="M197.43,74.69h21.71a0,0,0,0,1,0,0v19.9a3.75,3.75,0,0,1-3.75,3.75H201.18a3.75,3.75,0,0,1-3.75-3.75V74.69A0,0,0,0,1,197.43,74.69Z"
      transform="translate(416.25 173.8) rotate(-179.79)"
    />
    <circle fill="#464e5b" cx="207.68" cy="237.43" r="110.53" />
    <path fill="#fff" d="M300.22,237.43a94.36,94.36,0,0,1-.83,12.43,92.6,92.6,0,1,1,.83-12.43Z" />
    <rect fill="#23272e" x="206.5" y="147.37" width="3.66" height="9.22" />
    <rect fill="#23272e" x="206.5" y="318.27" width="3.66" height="9.22" />
    <rect
      fill="#23272e"
      x="291.3"
      y="232.82"
      width="3.66"
      height="9.22"
      transform="translate(530.56 -55.7) rotate(90)"
    />
    <rect
      fill="#23272e"
      x="120.39"
      y="232.82"
      width="3.66"
      height="9.22"
      transform="translate(359.65 115.2) rotate(90)"
    />
    <polygon fill="#e9523f" points="200.16 236 159.97 274.97 206.62 243.56 200.16 236" />
    <polygon fill="#e9523f" points="216.86 234.36 241.73 255.25 211.28 242.81 216.86 234.36" />
    <circle fill="#262e3c" cx="208.59" cy="235.6" r="8.52" transform="translate(-57.38 403.75) rotate(-80.78)" />
    <path fill="#fff" d="M202.85,235.6a5.74,5.74,0,1,1,5.74,5.73A5.74,5.74,0,0,1,202.85,235.6Z" />
    <path
      opacity="0.18"
      d="M207.29,330.59a93.47,93.47,0,0,1-12.49-.83c128.85-61.12,49.67-177.28,49.67-177.28h0a92.94,92.94,0,0,1-37.18,178.12Z"
    />
    <rect
      fill="#262e3c"
      x="249.83"
      y="157.49"
      width="1.68"
      height="6.38"
      transform="translate(114.15 -103.92) rotate(30.05)"
    />
    <rect
      fill="#262e3c"
      x="282.51"
      y="189.41"
      width="1.68"
      height="6.38"
      transform="translate(309.05 -149.05) rotate(60.1)"
    />
    <rect
      fill="#262e3c"
      x="283.42"
      y="277.6"
      width="1.68"
      height="6.38"
      transform="translate(669.92 176.34) rotate(120.2)"
    />
    <rect
      fill="#262e3c"
      x="251.47"
      y="310.2"
      width="1.68"
      height="6.38"
      transform="translate(626.89 460.24) rotate(150.24)"
    />
    <rect
      fill="#262e3c"
      x="163.26"
      y="310.98"
      width="1.68"
      height="6.38"
      transform="translate(147 668.21) rotate(-149.66)"
    />
    <rect
      fill="#262e3c"
      x="130.76"
      y="278.89"
      width="1.68"
      height="6.38"
      transform="translate(-48.65 535.86) rotate(-119.61)"
    />
    <rect
      fill="#262e3c"
      x="130.25"
      y="190.69"
      width="1.68"
      height="6.38"
      transform="translate(-102.49 208.45) rotate(-59.51)"
    />
    <rect
      fill="#262e3c"
      x="162.42"
      y="158.3"
      width="1.68"
      height="6.38"
      transform="translate(-58.31 101.17) rotate(-29.46)"
    />
  </svg>
))
